import React, { SyntheticEvent, useEffect, useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@material-ui/core';
import MuiLink from '@material-ui/core/Link';
import Box from '@material-ui/core/Box';
import { Auth } from 'aws-amplify';
import { useLocation } from 'react-router-dom';
import { useStyles } from './styles';
import { AlertContext } from '../../shared/app/AlertProvider';
import UnathorizedLayout from '../../shared/layout/UnauthorizedLayout';

const Success = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { showAlert } = useContext(AlertContext);

  const [username, setUsername] = useState('');
  const location = useLocation();

  const resendEmail = async (e: SyntheticEvent) => {
    e.preventDefault();
    Auth.resendSignUp(username).then(() => {
      showAlert({
        severity: 'success',
        message: t('v2.verification.snackbar_label_verificationEmailSentOut'),
      });
    });
  };

  useEffect(() => {
    setUsername(location?.state?.username);
  }, [location]);

  return (
    <UnathorizedLayout title={t('v2.verification.header_label_title')}>
      <Box component={Typography} p={4} pt={1}>
        {t('v2.verification.header_label_body')}
      </Box>
      {username !== '' && (
        <Box component={Typography} p={4} pt={1}>
          <Typography variant="body1">
            {t('v2.verification.label_resendEmail')}
            <MuiLink
              component="a"
              href="#"
              onClick={resendEmail}
              className={classes.links}
            >
              {t('v2.verification.button_resendEmail')}
            </MuiLink>
          </Typography>
        </Box>
      )}
    </UnathorizedLayout>
  );
};

export default Success;
